

$(document).ready(function() {

  $('.article-detail .page-container img, .page-detail .page-container img').each(function () {
    /*$(this).wrap($('<a/>', {
      href: $(this).attr('src'),
      class: "fancybox-thumb",
      rel: "fancybox-thumb"
    }));*/
  });
  
  //$('.product-single__image-slider a').addClass('fancybox-thumb');
  //$('.product-single__image-slider a').attr('rel','fancybox-thumb');

  $(".fancybox-thumb").fancybox({
    prevEffect	: 'none',
    nextEffect	: 'none',
    helpers	: {
      title	: {
        type: 'outside'
      },
      thumbs	: {
        width	: 50,
        height	: 50
      }
    }
  });
  
  
  //$('.photos__item--main a').addClass('fancybox-thumb2');
  //$('.photos__item--main a').attr('rel','fancybox-thumb2');
  $(".fancybox-thumb2").fancybox({
    prevEffect	: 'none',
    nextEffect	: 'none',
    helpers	: {
      title	: {
        type: 'outside'
      },
      thumbs	: {
        width	: 50,
        height	: 50
      }
    }
  });
});
